import { defHttp } from 'xmgoing-server';
import {axiosHelpers} from "@/api/request";
enum Api {
  getLayoutConfig = '/go-lcc/portalBoardConfig/getConfig',
  getPwdSettingUrl= '/pe-portal/securityMgSetting/getPwdSetting',
  //加载事件列表
  getTenantByAccount = '/pe-portal/users/getTenantByAccount',
  getUserById = '/pe-portal/users/read/',
}
/**
 * @description: 获取租户
 */
export async function getTenantByAccount(account: string) {
  return defHttp.get<any>({ url: Api.getTenantByAccount, params: { account } });
}

/**
 * get请求
 * @param url
 * @param params
 */
export function executeGetAsyncApi(url,params) {
  url=(url+'').replace("/api","/");
  return defHttp.post<any>({ url,params}, { errorMessageMode: 'none' });
}

/**
 * post请求
 * @param url
 * @param params
 */
export function executePostAsyncApi(url,params){
  url=(url+'').replace("/api","/");
  return defHttp.post<any>({ url,params}, { errorMessageMode: 'none' });
}

/**
 * 获取图片验证码图片
 * @param backFun
 */
export async function getImageCode(backFun) {
  const queryCommand=new QueryCommand({url:`/api/blade-auth/oauth/captcha`,method:'GET',showTip:false,errorFlag:false});
  queryCommand.executeQueryPromise({params:{}}).then((datas)=>{
    backFun&&backFun(datas);
  })
}

export function getPwdSetting(params = {}) {
  const data = {
    ...params,
    current: 1,
    size: 20,
  };
  return defHttp.post({ url: Api.getPwdSettingUrl, params: data });
}

// 登录操作
export const loginApi = (data) => {
  return axiosHelpers.post(URL.token, data, {
    headers: {
      authorization:
        "Basic c29tYnJlcm86OGIxMDY4MzctNjUwNC00NWI3LWFlOWQtOThmNzQxMWUwODQ1",
      "User-Type": 0,
    },
  });
};

/**
 * 根据用户id 获取用户信息
 * @param userId
 */
export async function getUserById(userId: string) {
  return defHttp.post<any>({ url: Api.getUserById + userId, params: {} });
}
